window.addEventListener("load", (event) => {
  var page = document.querySelector("body");
  var openDrawer = document.querySelector(".eg-open-info-drawer");
  var openModal = document.querySelectorAll(".eg-open-size-guide");
  var closeDrawer = '';
  var closeModal = '';
  var drawer = '';
  var modal = '';

  function init(type){
    switch(type){
      case 'drawer': closeDrawer = document.querySelector(".eg-close-info-drawer");
                     drawer = document.querySelector(".eg-info-drawer-container");
                     openDrawer.addEventListener('click', egOpenDrawer.bind(null, drawer, page));
                     closeDrawer.addEventListener('click', egCloseDrawer.bind(null, drawer, page));
                     break;
      case 'modal': closeModal = document.querySelector(".eg-close-size-guide");
                    modal = document.querySelector(".eg-popup-container");
                    openModal.forEach( el => {
                        el.addEventListener('click', egOpenModal.bind(null, modal, page));
                    });
                    closeModal.addEventListener('click', egCloseModal.bind(null, modal, page));
                    break;
      default: break;
    }
  }
  
  function egOpenDrawer(drawer, page, event){
    event.preventDefault();
    drawer.classList.add('show');
    page.classList.add('no-scroll');
  }

  function egOpenModal(modal, page, event){
    event.preventDefault();
    modal.classList.add('show');
    page.classList.add('no-scroll');
  }

  function egCloseDrawer(drawer, page, event){
    event.preventDefault();
    drawer.classList.remove('show');
    page.classList.remove('no-scroll');
  }

  function egCloseModal(modal, page, event){
    event.preventDefault();
    modal.classList.remove('show');
    page.classList.remove('no-scroll');
  }

  if(openDrawer != null){
    init('drawer');
  }
  
  if(openModal != null){
    init('modal');
  }
  
});